import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-552eb16c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-2" }
const _hoisted_2 = { class: "d-flex flex-column gap-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Código do ticket", -1))
const _hoisted_4 = { class: "d-flex flex-column gap-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Cnpj", -1))
const _hoisted_6 = { class: "d-flex flex-column gap-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Resumo", -1))
const _hoisted_8 = {
  key: 0,
  class: "d-flex flex-column gap-2"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Categoria", -1))
const _hoisted_10 = { class: "d-flex flex-column gap-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Status", -1))
const _hoisted_12 = { class: "d-flex flex-column gap-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Loja", -1))
const _hoisted_14 = { class: "d-flex flex-column gap-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Usuário do sistema", -1))
const _hoisted_16 = { class: "d-flex flex-column gap-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Solicitante", -1))
const _hoisted_18 = { class: "d-flex flex-column gap-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Data", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_FilterBase = _resolveComponent("FilterBase")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "attendance-filter",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.closeModal,
    disabledClick: true,
    onSearch: _ctx.sendFilter
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Selecione...",
            modelValue: _ctx.attendanceFilter.codigo,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.attendanceFilter.codigo) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Selecione...",
            modelValue: _ctx.attendanceFilter.cnpj,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.attendanceFilter.cnpj) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Selecione...",
            modelValue: _ctx.attendanceFilter.title,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.attendanceFilter.title) = $event))
          }, null, 8, ["modelValue"])
        ]),
        (_ctx.route.path === '/listaTickets')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_el_select, {
                filterable: "",
                placeholder: "Selecione...",
                clearable: "",
                modelValue: _ctx.attendanceFilter.category,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.attendanceFilter.category) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayCategory, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.name
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_el_select, {
            filterable: "",
            placeholder: "Selecione...",
            clearable: "",
            modelValue: _ctx.attendanceFilter.status,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.attendanceFilter.status) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayStatus, (status, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: status.name,
                  value: status.name
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_el_select, {
            filterable: "",
            placeholder: "Selecione...",
            clearable: "",
            "allow-create": "",
            modelValue: _ctx.attendanceFilter.store,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.attendanceFilter.store) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lojas, (loja, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: loja.nomeFantasia,
                  value: loja.cnpj
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_el_select, {
            filterable: "",
            clearable: "",
            placeholder: "Selecione...",
            clareable: "",
            modelValue: _ctx.attendanceFilter.support,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.attendanceFilter.support) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayUsers, (user, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: user.name,
                  value: user.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Selecione...",
            modelValue: _ctx.attendanceFilter.solicitante,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.attendanceFilter.solicitante) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.attendanceFilter.date,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.attendanceFilter.date) = $event)),
                type: "daterange",
                format: "DD/MM/YYYY",
                class: "w-100",
                style: {"border":"1.5px solid #dbdbdb","border-radius":"4px","height":"36px"},
                "start-placeholder": "inicial",
                "end-placeholder": "final"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["locale"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["closeModal", "onSearch"]))
}